<template>
    <div>
        <div id="container" style="min-width:400px;height:400px"></div>
    <p>*Click different sets in the Venn plot to obtain corresponding data in the table below.<br/></p>
    </div>
   
</template>
  
<script>

import Highcharts from 'highcharts'
export default({
    props:{
        activeOmics:String
    },
    data(){
        return{
            chartOptions:{},
            sets:[],
            snpOptions: {
                series: [{
                    type: "venn",
                    name: "SNP",
                    events:{
                        click: (e) => {
                            if(e.point.sets.length>=2)
                            this.$emit('click',e.point.sets,"snp");
                        }
                    },
                    data: [
                    {
                        sets: ["Major depressive disorder"],
                        value: 60,
                        true:1474,
                        name:"Major depressive disorder"
                    },
                    {
                        sets: ["Bipolar disorder"],
                        value: 60,
                        true:2944,
                        name:"Bipolar disorder"
                    },
                    {
                        sets: ["Schizophrenia"],
                        value: 60,
                        true:3131,
                        name:"Schizophrenia"
                    },
                    {
                        sets: ["Anxiety disorder"],
                        value: 60,
                        true:169,
                        name:"Anxiety disorder"
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder"],
                        value: 30,
                        true:183,
                        name: "MDD-BD",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia"],
                        value:30 ,
                        true:212,
                        name: "MDD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Anxiety disorder"],
                        value:30 ,
                        true:35,
                        name: "MDD-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia"],
                        value:30 ,
                        true:255,
                        name: "BD-SZ",
                    },
                    {
                        sets: ["Bipolar disorder",  "Anxiety disorder"],
                        value:30 ,
                        true:21,
                        name: "BD-AX",
                    },
                    {
                        sets: ["Schizophrenia", "Anxiety disorder"],
                        value:30 ,
                        true:40,
                        name: "SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia"],
                        value: 10,
                        true:106,
                        name: "MDD-BD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Anxiety disorder"],
                        value:10 ,
                        true:13,
                        name: "MDD-BD-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 10,
                        true:22,
                        name: "MDD-SZ-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value:10 ,
                        true:16,
                        name: "BD-SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 1,
                        true:12,
                        name: "MDD-BD-SZ-AX",
                    }
                    ],
                    showInLegend: true,
                }],
                
                title: {
                    text: "SNP Venn plot",
                },
                tooltip:{
                    formatter: function() {
                        return this.point.name+":"+this.point.true
                    },
                },
                
                
                credits: { enabled: false}
            },
            geneOptions: {
                series: [{
                    type: "venn",
                    name: "Gene",
                    events:{
                        click: (e) => {
                            if(e.point.sets.length>=2)
                            this.$emit('click',e.point.sets,"gene");
                        },
                        legendItemClick: function () {
                            console.log("hello")
                            var visibility = this.visible ? 'visible' : 'hidden';
                            if (!confirm('The series is currently ' +
                                        visibility + '. Do you want to change that?')) {
                                return false;
                            }
                        }
                    },
                    data: [
                    {
                        sets: ["Major depressive disorder"],
                        value: 60,
                        true:1396,
                        name:"Major depressive disorder"
                    },
                    {
                        sets: ["Bipolar disorder"],
                        value: 60,
                        true:6839,
                        name:"Bipolar disorder"
                    },
                    {
                        sets: ["Schizophrenia"],
                        value: 60,
                        true:11481,
                        name:"Schizophrenia"
                    },
                    {
                        sets: ["Anxiety disorder"],
                        value: 60,
                        true:795,
                        name:"Anxiety disorder"
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder"],
                        value: 30,
                        true:911,
                        name: "MDD-BD",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia"],
                        value: 30,
                        true:1149,
                        name: "MDD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Anxiety disorder"],
                        value: 30,
                        true:333,
                        name: "MDD-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia"],
                        value: 30,
                        true:4822,
                        name: "BD-SZ",
                    },
                    {
                        sets: ["Bipolar disorder",  "Anxiety disorder"],
                        value: 30,
                        true:489,
                        name: "BD-AX",
                    },
                    {
                        sets: ["Schizophrenia", "Anxiety disorder"],
                        value: 30,
                        true:670,
                        name: "SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia"],
                        value: 10,
                        true:800,
                        name: "MDD-BD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Anxiety disorder"],
                        value: 10,
                        true:240,
                        name: "MDD-BD-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 10,
                        true:308,
                        name: "MDD-SZ-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 10,
                        true:437,
                        name: "BD-SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 1,
                        true:233,
                        name: "MDD-BD-SZ-AX",
                    }],
                    showInLegend:true
                }],
                
                tooltip:{
                    formatter: function() {
                        return this.point.name+":"+this.point.true
                    },
                },
                title: {
                    text: "Gene Venn plot",
                },
                credits: { enabled: false}
            },
            rnaOptions: {
                series: [{
                    type: "venn",
                    name: "RNA",
                    events:{
                        click: (e) => {
                            if(e.point.sets.length>=2)
                            this.$emit('click',e.point.sets,"rna");
                        }
                    },
                    data: [
                    {
                        sets: ["Major depressive disorder"],
                        value: 60,
                        true:369,
                        name:"Major depressive disorder"
                    },
                    {
                        sets: ["Bipolar disorder"],
                        value: 60,
                        true:1058,
                        name:"Bipolar disorder"
                    },
                    {
                        sets: ["Schizophrenia"],
                        value: 60,
                        true:662,
                        name:"Schizophrenia"
                    },
                    {
                        sets: ["Anxiety disorder"],
                        value: 60,
                        true:35,
                        name:"Anxiety disorder"
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder"],
                        value: 30,
                        true:64,
                        name: "MDD-BD",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia"],
                        value: 30,
                        true:92,
                        name: "MDD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Anxiety disorder"],
                        value: 30,
                        true:17,
                        name: "MDD-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia"],
                        value: 30,
                        true:115,
                        name: "BD-SZ",
                    },
                    {
                        sets: ["Bipolar disorder",  "Anxiety disorder"],
                        value: 30,
                        true:14,
                        name: "BD-AX",
                    },
                    {
                        sets: ["Schizophrenia", "Anxiety disorder"],
                        value: 30,
                        true:18,
                        name: "SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia"],
                        value: 10,
                        true:46,
                        name: "MDD-BD-SZ",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Anxiety disorder"],
                        value: 10,
                        true:14,
                        name: "MDD-BD-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 10,
                        true:13,
                        name: "MDD-SZ-AX",
                    },
                    {
                        sets: ["Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 10,
                        true:14,
                        name: "BD-SZ-AX",
                    },
                    {
                        sets: ["Major depressive disorder", "Bipolar disorder", "Schizophrenia", "Anxiety disorder"],
                        value: 1,
                        true:14,
                        name: "MDD-BD-SZ-AX",
                    }],
                    showInLegend:true
                }],
                
                tooltip:{
                    formatter: function() {
                        return this.point.name+":"+this.point.true
                    },
                },
                title: {
                    text: "ncRNA Venn plot",
                },
                
                credits: { enabled: false}
            },
            methylationOptions: {
                series: [{
                    type: "venn",
                    name: "Methylation",
                    events:{
                        click: (e) => {
                            if(e.point.sets.length>=2)
                            this.$emit('click',e.point.sets,"methylation");
                        },
                    },
                    data: [
                    {
                        sets: ["Major depressive disorder"],
                        value: 70,
                        true:70,
                        name:"MDD"
                    },
                    {
                        sets: ["Schizophrenia"],
                        value: 70,
                        true:12098,
                        name:"Schizophrenia"
                    },
                    {
                        sets: ["Major depressive disorder", "Schizophrenia"],
                        value: 52,
                        true:52,
                        name: "MDD-BD",
                    },
                    ],
                    showInLegend:true
                }],
                tooltip:{
                    formatter: function() {
                        return this.point.name+":"+this.point.true
                    },
                },
                title: {
                    text: "Methylation Venn plot",
                },

                credits: { enabled: false}
            },
        }
    },
    mounted(){
        this.chartOptions=this.snpOptions
        this.freshPage() 
    },
    methods:{
        freshPage(){
            Highcharts.chart("container",this.chartOptions)
        }
    },
    watch: {
        activeOmics: {
            handler:function () {
                switch(this.activeOmics){
                    case 'snp':
                        this.chartOptions=this.snpOptions
                        break;
                    case 'gene':
                        this.chartOptions=this.geneOptions
                        break;
                    case 'rna':
                        this.chartOptions=this.rnaOptions
                        break;
                    case 'methylation':
                        this.title="Methylation Venn Diagram"
                        this.chartOptions=this.methylationOptions
                        break;
                }
                this.freshPage()
            },
        }
    }

})
   
</script>


